import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Backdrop,
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import CheckPermissions from "../../../authorization/authorization";
import BasicTable from "../../../components/basicTable/basicTable";
import { AllCFCs, AllPermissions } from "../../../network/APIs/APIs";
import { cfpBaseUrl } from "../../../network/urls";
import { tableStyle } from "../../../style/common";
import SearchIcon from "@mui/icons-material/Search";
import "./PermissionManagementTable.scss";
export default function PermissionManagementTable(props) {
  //#region
  const [newusersToDataGrid, setNewUsersToDataGrid] = useState([]);
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [open2, setopen2] = useState(false);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [dltuser, setdltuser] = useState();
  const [tablePermisson, setTablePermisson] = useState([]);
  const Navigate = useNavigate();
  const [viewBackdrop, setViewBackdrop] = React.useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [viewBackdropOfMainTable, setViewBackdropOfMainTable] =
    React.useState(true);
  const [tableDataLoaded, setTableDataLoaded] = useState(false);
  const handleCreatePermission = () => {
    const permissionData = tablePermisson; // Define your state here
    Navigate("/permission-management/new-permission", {
      state: permissionData,
    });
  };

  const { token, permissions } = useSelector((state) => state.auth);

  //#endregion
  useEffect(() => {
    if (!tableDataLoaded) return;
    apiToDataGridConversion();
    setViewBackdropOfMainTable(false);
  }, [tablePermisson, tableDataLoaded]);

  useEffect(() => {
    const getAllPermissions = async () => {
      setViewBackdropOfMainTable(true);
      setTableDataLoaded(false);
      let { allPermissions } = await AllPermissions(token, permissions);
      setTablePermisson(allPermissions || []);
      setTableDataLoaded(true);
    };
    getAllPermissions();
  }, []);

  const filterNCApp = (userId) => {
    const userdata = JSON.parse(window.localStorage.getItem("alluser"));
    const myArray = userdata;
    let itemFound = myArray.find((item) => item.userId === userId);
    return itemFound;
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setopen2(false);
  };

  const onDelete = async () => {
    var formdata = new FormData();
    formdata.append("idt", dltuser);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(cfpBaseUrl + "role/deletePermission", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          let myArray = JSON.parse(localStorage.getItem("all-permissions"));
          let index = myArray.findIndex((obj) => obj.id === dltuser);
          myArray.splice(index, 1);
          localStorage.setItem("all-permissions", JSON.stringify(myArray));
          setTablePermisson(myArray);
        } else {
        }
      })
      .catch(() => {});
    handleClose2();
  };

  const convertDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const convertdatetime = (datetimestring) => {
    if (datetimestring) {
      const converted = moment(datetimestring).format("llll");
      return converted;
    }
  };

  const CustomButton = styled(Button)({
    boxShadow: "none",
    textTransform: "none",
    fontSize: 13,
    padding: "6px 5px",
    border: "1px solid",
    color: "white",
    width: "2px",
    lineHeight: 1,
    backgroundColor: "#2e7d32",
    borderColor: "#2e7d32",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      backgroundColor: "#1b5e20",
      borderColor: "#1b5e20",
      color: "white",
      boxShadow: "none",
    },
  });

  const tblColumns = [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      sortable: false,
    },
    {
      field: "parent_idt",
      headerAlign: "center",
      headerName: "Parent ID",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      sortable: false,
    },
    {
      field: "name",
      headerAlign: "center",
      headerName: "Permission Title",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      sortable: false,
    },
    {
      field: "group",
      headerName: "Group Name",
      headerAlign: "center",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      sortable: false,
    },
    {
      field: "order",
      headerName: "Order",
      headerAlign: "center",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      sortable: false,
    },
    {
      field: "status",
      headerName: "Status",
      headerAlign: "center",
      align: "left",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      sortable: false,
    },
    // {
    //   headerName: "Action",
    //   sortable: false,
    //   headerAlign: 'center',
    //   align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle, sortable: false, filterable: false,
    //   field: 'buttons',
    //   renderCell: (params) => {
    //     const onViewUser = (e) => {
    //       e.stopPropagation(); // don't select this row after clicking
    //       const item = filterNCApp(params.userId);
    //       setDialogRowData(item);
    //       setOpen(true);

    //     };

    //     const onDeleteUser = (e) => {
    //       e.stopPropagation(); // don't select this row after clicking
    //       setopen2(true);
    //       setdltuser(params.id)
    //     }

    //     const onEditUser = (e) => {
    //       e.stopPropagation(); // don't select this row after clicking
    //       const userToEdit = filterNCApp(params.userId);
    //       Navigate('/user-management/update-user', { state: { userToEdit } })
    //     }
    //     return (
    //       <>
    //         <Box>
    //           <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }}>
    //             <ClearIcon fontSize="inherit" sx={{ color: 'orange' }} />
    //           </IconButton>
    //           {
    //             CheckPermissions(permissions, 'Access Management', 'Permission Management', 'Read') ?
    //               <IconButton onClick={onViewUser} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                 <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
    //               </IconButton> : null
    //           }
    //           {
    //             CheckPermissions(permissions, 'Access Management', 'Permission Management', 'Update') ?
    //               <IconButton onClick={onEditUser} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                 <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
    //               </IconButton> : null
    //           }
    //           {
    //             CheckPermissions(permissions, 'Access Management', 'Permission Management', 'Delete') ?
    //               <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteUser}>
    //                 <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
    //               </IconButton> : null
    //           }
    //         </Box>
    //       </>
    //     )
    //   }
    // }
  ];

  const apiToDataGridConversion = () => {
    let myArray = tablePermisson;
    const newArray = myArray.map((item) => {
      return { id: item.idt, ...item };
    });
    setNewUsersToDataGrid(newArray);
    setFilteredData(newArray);
  };
  const subDivisions = JSON.parse(window.localStorage.getItem("subDivisions"));

  const getCompanyName = (code) => {
    let companyObject = subDivisions.find((item) => item.companyCode === code);
    if (companyObject) {
      return companyObject.companyName;
    }
  };
  const getCircleName = (code) => {
    let circleObject = subDivisions.find((item) => item.circleCode === code);
    if (circleObject) {
      return circleObject.circleName;
    }
  };
  const getDivisionName = (code) => {
    let divisionObject = subDivisions.find(
      (item) => item.divisionCode === code,
    );
    if (divisionObject) {
      return divisionObject.divisionName;
    }
  };
  const getSubDivisionName = (code) => {
    let subDivisionObject = subDivisions.find(
      (item) => item.subDivisionCode === code,
    );
    if (subDivisionObject) {
      return subDivisionObject.subDivisionName;
    }
  };
  const getSupportCenterName = async (code) => {
    const allSupportCenters = await AllCFCs(
      token,
      permissions,
      code.slice(0, 2),
    );
    let supportCenterObject = allSupportCenters.find(
      (item) => item.cfcId == code,
    );
    if (supportCenterObject) {
      return supportCenterObject.cfcName;
    }
  };
  const handleSearch = (event) => {
    const query = event.target.value;

    setSearchQuery(query);

    const queryTrimmed = query.trim();

    if (queryTrimmed === "") {
      setFilteredData(newusersToDataGrid);
      return;
    }

    const queryLower = queryTrimmed.toLowerCase();

    const filtered = newusersToDataGrid.filter((row) =>
      Object.values(row).some(
        (val) => val != null && String(val).toLowerCase().includes(queryLower),
      ),
    );

    setFilteredData(filtered);
  };

  return (
    <>
      <Box className="form-box permission-management-list">
        {/* <Box className="main-heading">
          <h2>
            Permission Management
          </h2>
          <div className="btn2">
            {CheckPermissions(permissions,"Access Management", "User Management") && (
              // <Link to="/permission-management/new-permission">
              <Button

                variant="contained"
                size="small"
                className="btnNewApplication"
                startIcon={<AddCircleIcon />}
                onClick={handleCreatePermission}
              >
                Create New Permission
              </Button>
              // </Link>
            )}
          </div>
        </Box> */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <h3 className="page-title">Permission Management</h3>

          <div
            style={{
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
              padding: "5px 10px",
              border: "1px solid grey",
              margin: "0px",
            }}
          >
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearch}
              placeholder="Search by ID, Permission Title or Group Name"
              maxLength={20}
              style={{
                flex: 1,
                padding: "8px",
                border: "none",
                backgroundColor: "transparent",
                outline: "none",
                fontSize: "13px",
                minWidth: "300px",
              }}
            />
            <SearchIcon
              sx={{
                color: "#09669d",
                width: 30,
                height: 30,
                borderRadius: "8px",
                padding: "6px",
                cursor: "pointer",
                transition: "background-color 0.3s",
                "&:hover": {
                  color: "#074f7d",
                },
              }}
            />
          </div>
        </Box>
        <Box className="application-table">
          <BasicTable
            data={filteredData}
            columns={tblColumns}
            sx={tableStyle}
            rowHeight={37.5}
            pageSize={18}
            handleRowClick={() => {}}
            rowsPerPageOptions={[18, 30, 60]}
            rowsPageOption={false}
            getRowStyle={(params) => {
              return params.indexRelativeToCurrentPage % 2 === 0
                ? tableStyle.evenRow
                : tableStyle.oddRow;
            }}
          />
        </Box>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // fullWidth={true}
        // maxWidth={'sm'}
        PaperProps={{ sx: { width: "30%" } }}
      >
        <DialogTitle id="alert-dialog-title" className="dialog-title">
          <IconButton
            onClick={handleClose}
            sx={{ position: "relative", float: "right" }}
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ fontWeight: "bold" }}>User Details</Typography>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignitem: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ marginTop: "35px" }}>
              <Typography sx={{ fontWeight: "bold" }}>
                Profile Picture
              </Typography>
            </Box>
            <Box>
              <img
                src={dialogRowData.profilePicture}
                height="100"
                width="100"
                alt="avatar"
              />
            </Box>
          </Box>
          <DialogContentText id="alert-dialog-description">
            <hr />
            <Grid
              className="content-grid"
              sx={{ mt: "17px", display: "flex", flexDirection: "column" }}
            >
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>ID:</h5>
                  <span>{dialogRowData.id}</span>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Name:</h5>
                  <p>{dialogRowData.name}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Username:</h5>
                  <p>{dialogRowData.userId}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>E-mail:</h5>
                  <p>{dialogRowData.email}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>status:</h5>
                  <p>Active</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Role:</h5>
                  <p>{dialogRowData.roleName}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Confirmed:</h5>
                  <p>{<CustomButton>Yes</CustomButton>}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Created-By:</h5>
                  <p>{dialogRowData.created_by}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Created-At:</h5>
                  <p>{convertdatetime(dialogRowData.created_at)}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Last Updated By:</h5>
                  <p>{dialogRowData.updated_by}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Last Updated At:</h5>
                  <p>{dialogRowData.updated_at}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Phone No:</h5>
                  <p style={{ marginBottom: "30px" }}>
                    {dialogRowData.phoneNo}
                  </p>
                </Box>
                <hr />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>Company:</h5>
                  <p>
                    {getCompanyName(dialogRowData.companyCode)
                      ? getCompanyName(dialogRowData.companyCode)
                      : "PITC"}
                  </p>
                </Box>
                {dialogRowData.hierarchy >= 3 && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>Circle:</h5>
                    <p>{getCircleName(dialogRowData.circleCode)}</p>
                  </Box>
                )}
                {dialogRowData.hierarchy >= 4 && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>Division:</h5>
                    <p>{getDivisionName(dialogRowData.divisionCode)}</p>
                  </Box>
                )}
                {dialogRowData.hierarchy === 51 && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>Support Center:</h5>
                    <p>{getSupportCenterName(dialogRowData.cscId)}</p>
                  </Box>
                )}
                {dialogRowData.hierarchy === 52 && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <h5>Sub Division:</h5>
                    <p style={{ marginBottom: "30px" }}>
                      {getSubDivisionName(dialogRowData.subDivisionCode)}
                    </p>
                  </Box>
                )}
              </Box>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {" Are you sure to delete this record"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose2}>Cancel</Button>
          <Button onClick={onDelete} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop || viewBackdropOfMainTable}
      >
        <AppLoader />
      </Backdrop>
    </>
  );
}
